import { Component } from 'react';
import service from '../../core/service';
interface IProps {
}
interface IState {
    str: string;
    value: string,
    openModal: boolean,
    name: string;
    family: string;
    nationalCode: string;
    insurancePolicyNumber: string;
    installment: any;
    page: number;
    loading?:boolean;
}

export class InstallmentController extends Component<IProps, IState> {
    state: IState = {
        str: "",
        value: "",
        openModal: false,
        name: "",
        family: "",
        nationalCode: "",
        insurancePolicyNumber: "",
        installment: [],
        page: 1,
        loading:false
    };
    search = async (e: any) => {
        this.setState({ str: e })
    };
    handleChange = (e: any) => {
        this.setState({ value: e.target.value })
    };
    paginationTimeOut: string | number | NodeJS.Timeout | undefined;
    handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
        this.setState({ page: value })
        clearTimeout(this.paginationTimeOut);
        this.paginationTimeOut = setTimeout(() => {
            this.getList()
        }, 800);
    }
    getList = async () => {
        this.setState({ loading: true })
        try {
            const response = await service.Installment.list();
            if (response) {
                this.setState({ installment: response?.data?.data?.data })
                this.setState({ loading: false })

            }else{
        this.setState({ loading: false })

            }
        } catch (error) {
        this.setState({ loading: false })

            // throw error;
        }
    };
}
export default InstallmentController;